// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICheckVoidDto
 */
export interface ICheckVoidDto {
    /**
     * 
     * @type {string}
     * @memberof ICheckVoidDto
     */
    void_reason?: string;
}

/**
 * Check if a given object implements the ICheckVoidDto interface.
 */
export function instanceOfICheckVoidDto(value: object): value is ICheckVoidDto {
    return true;
}

export function ICheckVoidDtoFromJSON(json: any): ICheckVoidDto {
    return ICheckVoidDtoFromJSONTyped(json, false);
}

export function ICheckVoidDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICheckVoidDto {
    if (json == null) {
        return json;
    }
    return {
        
        'void_reason': json['void_reason'] == null ? undefined : json['void_reason'],
    };
}

export function ICheckVoidDtoToJSON(json: any): ICheckVoidDto {
    return ICheckVoidDtoToJSONTyped(json, false);
}

export function ICheckVoidDtoToJSONTyped(value?: ICheckVoidDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'void_reason': value['void_reason'],
    };
}

